export default class Operator {
    constructor(public id: number, public symbol: string, public label: string) {
    }
    public test(userValue: any, conditionValue: any) {
        switch (this.symbol) {
            case '=' :
                return userValue == conditionValue;
            case '!=':
                return userValue != conditionValue;
            case '<':
                return parseFloat(userValue) < parseFloat(conditionValue);
            case '>':
                return parseFloat(userValue) > parseFloat(conditionValue);
            case '<=':
                return parseFloat(userValue) <= parseFloat(conditionValue);
            case '>=':
                return parseFloat(userValue) >= parseFloat(conditionValue);
        }
    }
}
